"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _react = _interopRequireDefault(require("react"));
var _Grow = _interopRequireDefault(require("@mui/material/Grow"));
var _Paper = _interopRequireDefault(require("@mui/material/Paper"));
var _classnames = _interopRequireDefault(require("classnames"));
var _HiSelectableList = _interopRequireDefault(require("../HiSelectableList"));
var _HiInput = _interopRequireDefault(require("../HiForm/HiInput"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var _Popper = _interopRequireDefault(require("@mui/material/Popper"));
var _helpers = require("../utils/helpers");
var _keycode = _interopRequireDefault(require("keycode"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // @inheritedComponent HiInput
var styles = exports.styles = function styles(theme) {
  return {
    root: {
      backgroundColor: theme.palette.background2,
      minWidth: 200,
      width: '100%'
    },
    popper: {
      width: '100% !important',
      transform: 'none !important',
      zIndex: '9 !important',
      top: '100% !important',
      textOverflow: 'ellipsis'
    },
    paper: {
      borderRadius: '0px 2px',
      maxHeight: 440,
      transition: 'none'
    },
    alignRight: {
      right: 0
    }
  };
};
var HiSuggestSelect = /*#__PURE__*/function (_React$PureComponent) {
  function HiSuggestSelect(props) {
    var _this;
    (0, _classCallCheck2.default)(this, HiSuggestSelect);
    _this = _callSuper(this, HiSuggestSelect, [props]);
    _this.getInputElement = function (el) {
      _this.textInput = el;
      if (_this.props.inputRef) {
        _this.props.inputRef(_this.textInput);
      }
    };
    _this.handleSelect = function (event, value) {
      document.body.style.overflow = 'auto';
      _this.props.onSelect(event, value);
      var textInput = _this.textInput;
      if (textInput) {
        setTimeout(function () {
          textInput.focus();
          textInput.scrollLeft = textInput.scrollWidth;
        }, 1);
      }
    };
    // Key down on list items
    _this.handleKeyDown = function (event) {
      var nextItem;
      var key = (0, _keycode.default)(event);
      if (key === 'down') {
        event.preventDefault();
        nextItem = (0, _helpers.getNextItemSelectable)(document.activeElement, 'down');
      } else if (key === 'up') {
        event.preventDefault();
        nextItem = (0, _helpers.getNextItemSelectable)(document.activeElement, 'up');
      } else if (key === 'tab') {
        document.body.style.overflow = 'auto';
        if ((0, _helpers.getNextItemSelectable)(document.activeElement, 'down') === null) {
          _this.setState({
            options: [],
            focused: false,
            suggestionFocusIndex: -1
          });
          if (_this.props.onBlurInput) {
            _this.props.onBlurInput(event);
          }
        }
      } else if (key === 'escape' || 'enter') {
        event.preventDefault();
        var item = _this.props.options.find(function (elem) {
          return String(elem.id) === event.target.id;
        });
        _this.handleSelect(null, item);
      }
      if (nextItem) {
        nextItem.focus();
      }
    };
    // Key down on search input
    _this.handleKeyDownSearch = function (event) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (_this.state.suggestionFocusIndex < _this.props.options.length - 1) {
          _this.setState(function (prevState) {
            return {
              suggestionFocusIndex: prevState.suggestionFocusIndex + 1
            };
          });
        }
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (_this.state.suggestionFocusIndex >= 0) {
          _this.setState(function (prevState) {
            return {
              suggestionFocusIndex: prevState.suggestionFocusIndex - 1
            };
          });
        }
      } else if (event.key === 'Enter' && _this.state.suggestionFocusIndex >= 0) {
        event.preventDefault();
        // Suggestion focused
        _this.handleSelect(event, _this.state.options[_this.state.suggestionFocusIndex]);
      } else if (event.key === 'Escape') {
        _this.setState({
          options: [],
          suggestionFocusIndex: -1
        });
      }
    };
    _this.handleFocus = function (event) {
      _this.setState({
        focused: true
      });
      if (_this.props.onFocusInput) {
        _this.props.onFocusInput(event);
      }
    };
    _this.handleBlur = function (event) {
      // Si on click sur un élément de HiInput, on garde le focus
      // Par exemple sur l'icone reset
      if (!event.relatedTarget || !_this.overlay || !_this.overlay.contains(event.relatedTarget)) {
        _this.setState({
          options: [],
          focused: false,
          suggestionFocusIndex: -1
        });
        if (_this.props.onBlurInput) {
          _this.props.onBlurInput(event);
        }
      } else if (event.relatedTarget && event.relatedTarget.attributes.disabled && _this.overlay && !_this.overlay.contains(event.relatedTarget)) {
        _this.setState({
          options: [],
          suggestionFocusIndex: -1
        });
        if (_this.textInput) {
          _this.textInput.focus();
        }
      }
    };
    _this.state = {
      focused: false,
      options: props.options,
      suggestionFocusIndex: -1
    };
    return _this;
  }
  (0, _inherits2.default)(HiSuggestSelect, _React$PureComponent);
  return (0, _createClass2.default)(HiSuggestSelect, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        id = _this$props.id,
        loading = _this$props.loading,
        showMinLength = _this$props.showMinLength,
        showNoResults = _this$props.showNoResults,
        onSearch = _this$props.onSearch,
        translations = _this$props.translations,
        align = _this$props.align,
        inputClasses = _this$props.inputClasses,
        _this$props$HiInputPr = _this$props.HiInputProps,
        HiInputProps = _this$props$HiInputPr === void 0 ? {} : _this$props$HiInputPr,
        otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "id", "loading", "showMinLength", "showNoResults", "onSearch", "translations", "align", "inputClasses", "HiInputProps"]);
      var _this$state = this.state,
        focused = _this$state.focused,
        options = _this$state.options,
        suggestionFocusIndex = _this$state.suggestionFocusIndex;
      var optionsShown = options;

      // If loading
      if (loading) {
        optionsShown = [{
          id: '_loading',
          type: 'loader',
          disabled: true,
          centered: true,
          checkbox: false,
          label: 'loading'
        }];
      } else if (options.length === 0 && (showNoResults || showMinLength)) {
        // If no result match
        optionsShown = [{
          id: '_no_result',
          type: 'text',
          disabled: true,
          centered: true,
          checkbox: false,
          label: showNoResults ? translations.no_result_match : translations.min_length,
          selectable: false
        }];
      }
      var open = !!optionsShown.length && focused;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes.root,
        ref: function ref(el) {
          _this2.overlay = el;
        }
      }, /*#__PURE__*/_react.default.createElement(_HiInput.default, (0, _extends2.default)({}, otherProps, {
        inputId: id,
        focused: focused,
        inputRef: this.getInputElement,
        onChange: onSearch,
        onKeyDown: this.handleKeyDownSearch,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        classes: inputClasses,
        inputProps: (0, _objectSpread2.default)({}, HiInputProps)
      })), open && /*#__PURE__*/_react.default.createElement(_Popper.default, {
        disablePortal: true,
        anchorEl: this.textInput,
        placement: "bottom-start",
        className: (0, _classnames.default)(classes.popper, (0, _defineProperty2.default)({}, classes.alignRight, align === 'right')),
        open: true
      }, /*#__PURE__*/_react.default.createElement(_Grow.default, {
        in: open,
        id: "menu-list",
        style: {
          transformOrigin: '0 0 0'
        }
      }, /*#__PURE__*/_react.default.createElement(_Paper.default, {
        className: classes.paper
      }, /*#__PURE__*/_react.default.createElement(_HiSelectableList.default, {
        itemList: optionsShown,
        selectedIdList: [],
        hideCheckbox: true,
        onSelect: this.handleSelect,
        translations: translations,
        onKeyDown: this.handleKeyDown,
        suggestionFocusIndex: suggestionFocusIndex
      })))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (JSON.stringify(props.options) !== JSON.stringify(state.options)) {
        return {
          options: props.options,
          suggestionFocusIndex: -1
        };
      }
      return null;
    }
  }]);
}(_react.default.PureComponent);
HiSuggestSelect.defaultProps = {
  align: 'left',
  showMinLength: false,
  showNoResults: false,
  translations: {
    no_result_match: 'Aucun résultat correspondant',
    min_length: 'Veuillez saisir 3 caractères minimum'
  },
  options: []
};
var _default = exports.default = (0, _withStyles.default)(styles, {
  hiComponent: true,
  name: 'HmuiHiSuggestSelect'
})(HiSuggestSelect);